// @ts-nocheck
import {ref, Ref} from "vue"

const $site: Ref<any | null> = ref(null)

export default $site